<ion-app>
	<ion-split-pane contentId="main-content" when="xl">

		<ion-menu contentId="main-content" mode="md">

			<!-- <ng-container *ngIf="Session.HasAllData"> -->
			<ion-header no-border>
				<sidemenu-header></sidemenu-header>
			</ion-header>

			<ion-content customScrollbar styleType="dark">
				<sidemenu-content></sidemenu-content>
			</ion-content>

			<ion-footer no-border>
				<sidemenu-footer></sidemenu-footer>
			</ion-footer>
			<!-- </ng-container> -->

		</ion-menu>

		<ion-router-outlet id="main-content"></ion-router-outlet>
	</ion-split-pane>
</ion-app>